import React from "react";
import { LegalLayout } from "../components/LegalLayout";

export default function TermsPage() {
  return <LegalLayout pageKey="terms" accent="amber" />;
}
